<template>
  <div class="app-container" style="padding: 0;">
    <div class="wt-form-inputs-container">
      <div class="wt-form-inputs-content">
        <el-form size="small" :inline="true" class="wt-form-inputs">
          <el-form-item label="统计时间：">
            <el-select v-model="form.type" filterable placeholder="请选择">
              <el-option
                v-for="item in dateList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-button size="small" type="primary" @click="toClickAction('search')">查询</el-button>
          <el-button size="small" @click="toClickAction('reset')">重置</el-button>
        </el-form>
      </div>
      <div class="dashboard-container">
        <div class="card-wrapper">
          <!-- 1. 实时投递数据 -->
          <div class="data-card blue-card">
            <h3 class="card-title">实时投递数据</h3>
            <div class="card-content">
              <div class="data-row">
                <span class="data-label">投递重量:</span>
                <span class="data-value">{{ (this.detail.deliverTime[0].tdzl/1000).toFixed(2) }} 吨</span>
                <span class="data-label">投递次数:</span>
                <span class="data-value">{{ this.detail.deliverTime[0].tdcs }} 次</span>
              </div>
              <div class="data-row">
                <span class="data-label">清运总量:</span>
                <span class="data-value">{{ (this.detail.clearTime[0].qyzl/1000).toFixed(2) }} 吨</span>
                <span class="data-label">清运台数:</span>
                <span class="data-value">{{ this.detail.clearTime[0].wtsb }} 台</span>
              </div>
              <div class="data-row">
                <span class="data-label">清运次数:</span>
                <span class="data-value">{{ this.detail.clearTime[0].qycs }} 次</span>
                <span class="data-label">违投次数:</span>
                <span class="data-value">{{ this.detail.clearTime[0].wtcs }} 次</span>
              </div>
            </div>
          </div>

          <!-- 2. 财务数据 -->
          <div class="data-card green-card">
            <h3 class="card-title">财务数据</h3>
            <div class="card-content">
              <div class="data-row">
                <span class="data-label">分润金额:</span>
                <span class="data-value">{{ this.detail.clearTime[0].frje }} 元</span>
                <span class="data-label">提现金额:</span>
                <span class="data-value">{{ this.detail.financeStatistics.txje }} 元</span>
              </div>
              <div class="data-row">
                <span class="data-label">投递金额:</span>
                <span class="data-value">{{ this.detail.deliverTime[0].tdje }} 元</span>
                <span class="data-label">用户余额:</span>
                <span class="data-value">{{ this.detail.financeStatistics.yhye }} 元</span>
              </div>
              <div class="data-row">
                <span class="data-label">清运金额:</span>
                <span class="data-value">{{ this.detail.clearTime[0].qyje }} 元</span>
                <span class="data-label">充值金额:</span>
                <span class="data-value">{{ this.detail.financeStatistics.czje }} 元</span>
              </div>
              <div class="data-row">
                <span class="data-label">开箱金额:</span>
                <span class="data-value">{{ this.detail.financeStatistics.kxje }} 元</span>
                <span class="data-label">充值余额:</span>
                <span class="data-value">{{ this.detail.financeStatistics.czye }} 元</span>
              </div>
            </div>
          </div>

          <!-- 3. 设备数据 -->
          <div class="data-card purple-card">
            <h3 class="card-title">设备数据</h3>
            <div class="card-content">
              <div class="data-row">
                <span class="data-label">回收箱数量:</span>
                <span class="data-value">{{ this.detail.countHardware.find(item => item.countHardware !== undefined)?.countHardware || 0 }} 个</span>
                <span class="data-label">离线数量:</span>
                <span class="data-value">{{ this.detail.countHardware.find(item => item.lxsl !== undefined)?.lxsl || 0 }} 个</span>
              </div>
              <div class="data-row">
                <span class="data-label">满溢数量:</span>
                <span class="data-value">{{ this.detail.countHardware.find(item => item.countHardwareM !== undefined)?.countHardwareM || 0 }} 个</span>
                <span class="data-label">异常数量:</span>
                <span class="data-value">{{ this.detail.countHardware.find(item => item.ycsl !== undefined)?.ycsl || 0 }} 个</span>
              </div>
              <div class="data-row">
                <span class="data-label">在线数量:</span>
                <span class="data-value">{{ this.detail.countHardware.find(item => item.zxsl !== undefined)?.zxsl || 0 }} 个</span>
              </div>
            </div>
          </div>

          <!-- 4. 公司数据 -->
          <div class="data-card red-card">
            <h3 class="card-title">公司数据</h3>
            <div class="card-content">
              <div class="data-row">
                <span class="data-label">公司数量:</span>
                <span class="data-value">1</span>
              </div>
              <div class="data-row">
                <span class="data-label">清运员:</span>
                <span class="data-value">{{ this.detail.countHardware.find(item => item.totalUser !== undefined)?.totalUser || 0 }} 人</span>
              </div>
            </div>
          </div>

          <!-- 5. 用户统计 -->
          <div class="data-card orange-card">
            <h3 class="card-title">用户统计</h3>
            <div class="card-content">
              <div class="data-row">
                <span class="data-label">总用户:</span>
                <span class="data-value">{{ this.detail.deliverTime[0].yhzl }} 人</span>
              </div>
              <div class="data-row">
                <span class="data-label">新增用户:</span>
                <span class="data-value">{{ this.detail.deliverTime[0].xzyh }} 人</span>
              </div>
              <div class="data-row">
                <span class="data-label">投递人数:</span>
                <span class="data-value">{{ this.detail.deliverTime[0].tdrs }} 人</span>
              </div>
            </div>
          </div>
        </div>

        <div class="bottom-info-row">
          <div class="info-item">
            <span class="info-label">投递重量:</span>
            <span class="info-value">{{ this.detail.deliverTime[0].tdzl }} kg</span>
          </div>
          <div class="info-item">
            <span class="info-label">投递金额:</span>
            <span class="info-value">{{ this.detail.deliverTime[0].tdje }} 元</span>
          </div>
          <div class="info-item">
            <span class="info-label">投递次数:</span>
            <span class="info-value">{{ this.detail.deliverTime[0].tdcs }} 次</span>
          </div>
          <div class="info-item">
            <span class="info-label">设备数量:</span>
            <span class="info-value">{{ this.detail.countHardware.find(item => item.countHardware !== undefined)?.countHardware || 0 }} 台</span>
          </div>
        </div>
        <div class="bottom-info-row">
          <div class="info-item">
            <span class="info-label">清运重量:</span>
            <span class="info-value">{{ this.detail.clearTime[0].qyzl }} kg</span>
          </div>
          <div class="info-item">
            <span class="info-label">清运金额:</span>
            <span class="info-value">{{ this.detail.clearTime[0].qyje }} 元</span>
          </div>
          <div class="info-item">
            <span class="info-label">清运台数:</span>
            <span class="info-value">{{ this.detail.clearTime[0].wtsb }} 次</span>
          </div>
          <div class="info-item">
            <span class="info-label">清运员数量:</span>
            <span class="info-value">{{ this.detail.countHardware.find(item => item.totalUser !== undefined)?.totalUser || 0 }} 人</span>
          </div>
        </div>
      </div>

      <div class="data-chart-wrapper">
        <!-- 投递趋势卡片 -->
        <el-card class="chart-card">
          <div class="card-header">
            <div class="title">投递趋势</div>
            <div class="tip">较昨日: {{ (diff = detail.deliverTime[0]?.tdzl - detail.deliverTime[1]?.tdzl || 0) > 0
              ? '↑' + diff.toFixed(2)
              : '↓' + Math.abs(diff).toFixed(2)  }} kg</div>
          </div>
          <LineChart :chartData="tdList"></LineChart>
        </el-card>

        <!-- 清运趋势卡片 -->
        <el-card class="chart-card">
          <div class="card-header">
            <div class="title">清运趋势</div>
            <div class="tip">较昨日: {{ (diff = detail.clearTime[0]?.qyzl - detail.clearTime[1]?.qyzl || 0) > 0
              ? '↑' + diff.toFixed(2)
              : '↓' + Math.abs(diff).toFixed(2)  }} kg</div>
          </div>
          <LineChart :chartData="qyList"></LineChart>
        </el-card>

        <!-- 用户增长趋势卡片 -->
        <el-card class="chart-card">
          <div class="card-header">
            <div class="title">用户增长趋势</div>
            <div class="tip">较昨日: {{ (diff = detail.deliverTime[0]?.xzyh - detail.deliverTime[1]?.xzyh || 0) > 0
              ? '↑' + diff
              : '↓' + Math.abs(diff)  }} 人</div>
          </div>
          <LineChart :chartData="yhList"></LineChart>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OneDetail',
  isAutoComponent: true,
  data() {
    return {
      form: {
        type: 'day'
      },
      detail: {},
      dateList: [
        { label: '天', value: 'day' },
        { label: '周', value: 'week' },
        { label: '月', value: 'month' },
        { label: '年', value: 'year' }
      ],
      tdList: {},
      qyList: {},
      yhList: {}
    }
  },
  created() {
    this.initPage()
  },
  mounted() {
    const that = this
    window.addEventListener('resize', that.resizeView)
    this.initPage()
  },
  beforeDestroy() {
    const that = this
    window.removeEventListener('resize', that.resizeView)
  },
  methods: {
    // 初始化页面
    initPage() {
      this.$api.statistical.workbenchIndex.index(this.form).then(res => {
        let date = []
        let dateOne = []
        if (this.form.type === 'day') {
          date = res.data.deliverTime.map(item => item.statDay)
          dateOne = res.data.clearTime.map(item => item.statDay)
        } else if (this.form.type === 'week') {
          date = res.data.deliverTime.map(item => item.statWeek)
          dateOne = res.data.clearTime.map(item => item.statWeek)
        } else if (this.form.type === 'month') {
          date = res.data.deliverTime.map(item => item.statMonth)
          dateOne = res.data.clearTime.map(item => item.statMonth)
        } else if (this.form.type === 'year') {
          date = res.data.deliverTime.map(item => item.statYear)
          dateOne = res.data.clearTime.map(item => item.statYear)
        }
        this.tdList = {
          xAxisData: date,
          line: [
            { name: '',
              data: res.data.deliverTime.map(item => item.tdzl),
              label: true,
              color: '#409EFF',
              areaColor: '#ECF6FF' }
          ]
        }
        this.qyList = {
          xAxisData: dateOne,
          line: [
            { name: '',
              data: res.data.clearTime.map(item => item.qyzl),
              label: true,
              color: '#67C23A',
              areaColor: '#F0F9EC' }
          ]
        }
        this.yhList = {
          xAxisData: date,
          line: [
            { name: '',
              data: res.data.deliverTime.map(item => item.xzyh),
              label: true,
              color: '#E6A23C',
              areaColor: '#FDF6EC' }
          ] }
        this.detail = res.data
      })
    },
    toClickAction(type) {
      if (type === 'reset') {
        this.form = {
          type: ''
        }
      }
      this.initPage()
    }
  }
}
</script>

<style lang="scss" scoped>
/* 外层容器 */
.dashboard-container {
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
}

/* 核心：卡片容器布局优化 */
.card-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: stretch; /* 关键：让卡片自动拉伸占满空间 */
  width: 100%;
  margin-bottom: 20px;
}

/* ======================
   卡片宽度分配：解决空白问题
====================== */
/* 前3个卡片：内容多，分配更多空间 */
.blue-card,
.green-card,
.purple-card {
  flex: 3; /* 占比3份 */
  min-width: 280px;
}

/* 后2个卡片：内容少，分配较少空间 */
.red-card,
.orange-card {
  flex: 2; /* 占比2份 */
  min-width: 180px;
}

/* 所有卡片统一样式 */
.data-card {
  height: 220px; /* 固定高度 */
  padding: 20px;
  border-radius: 8px;
  color: #fff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.card-title {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  margin: 0 0 12px 0;
}

.card-content {
  flex: 1;
  text-align: left;
}

/* ======================
   内容对齐与换行优化
====================== */
.data-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 14px;
  margin: 6px 0;
  line-height: 1.5;
}

/* 标签固定宽度，保证竖排对齐 */
.data-label {
  flex: 0 0 10px;
  white-space: nowrap;
}

/* 数值自动换行，不超出卡片 */
.data-value {
  flex: 1;
  min-width: 0;
  white-space: normal;
  word-break: break-all;
}

/* 卡片背景色 - 毛玻璃效果 */
.blue-card {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.8) 0%, rgba(118, 75, 162, 0.8) 100%);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2);
}
.green-card {
  background: linear-gradient(135deg, rgba(17, 153, 142, 0.8) 0%, rgba(56, 239, 125, 0.8) 100%);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 20px rgba(17, 153, 142, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2);
}
.purple-card {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.85) 0%, rgba(168, 85, 247, 0.85) 100%);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 16px rgba(99, 102, 241, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2);
}
.red-card {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.85) 0%, rgba(236, 72, 153, 0.85) 100%);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 16px rgba(239, 68, 68, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2);
}
.orange-card {
  background: linear-gradient(135deg, rgba(249, 115, 22, 0.85) 0%, rgba(234, 88, 12, 0.85) 100%);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 16px rgba(249, 115, 22, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.bottom-info-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 12px 0;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #eee;
}

.info-item {
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 160px;
}

.info-label {
  flex: 0 0 110px;
  white-space: nowrap;
}

.info-value {
  flex: 1;
  white-space: nowrap;
  text-align: left;
}

.data-chart-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 16px;
  box-sizing: border-box;
  width: 100%;
}

/* 卡片：一行3个，自动拉伸，1920无空白 */
.chart-card {
  flex: 1;
  min-width: 340px;
  //min-height: 390px;
  height: calc(35vh);
  border-radius: 8px;
  overflow: hidden;

  ::v-deep .el-card__body {
    padding: 0 !important;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}

/* 卡片头部 */
.card-header {
  padding: 16px;
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
  .tip {
    font-size: 14px;
    color: #666;
    margin-top: 4px;
  }
}

/* 图表容器 */
.chart-box {
  flex: 1;
  width: 100%;
  height: calc(100% - 70px);
}
</style>
